<template>
  <b-modal
    centered
    :id="id"
    :title="action"
    header-border-variant="white"
    footer-border-variant="white"
    content-class="modal-overlay"
    title-class="modal-title-override text-muted"
    body-class="modal-body-override"
    @hide="__onHide"
    @cancel="__onCancel"
    @ok="__onConfirm"
    :visible="isShown"
  >
    <!-- Corps -->
    <template v-slot:default>
      <p>{{ "components.modals.confirmationBox.body" | i18n }}</p>
    </template>

    <!-- Footer -->
    <template v-slot:modal-footer="{ cancel, ok }">
      <button class="btn btn-white modal-btn" variant="light" @click="cancel">
        {{ "components.modals.confirmationBox.negativeResponse" | i18n }}
      </button>
      <button class="btn btn-primary modal-btn" @click="ok">
        {{ action }}
      </button>
    </template>
  </b-modal>
</template>

<script>
/**
 * @description Composant permettant d'afficher une boîte de dialogue pour demander une confirmation
 * @author Alexandre Gallant
 * @author Francine Jin
 * @vue-prop {String} id - Id à donner au composant
 * @vue-prop {String} action - Action pour laquelle on veut demander une confirmation
 * @vue-prop {Boolean} isShown - Si on doit afficher la boite modale
 * @vue-event {String} confirmed - Est émis quand le formulaire est validé
 * @vue-event {String} canceled - Est émis quand le formulaire est annulé
 */
export default {
  name: "ConfirmationBox",
  props: {
    id: {
      type: String,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    isShown: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    /**
     * @description Émet l'évènement « confirmed »
     */
    __onConfirm() {
      this.$emit("confirmed", this.id);
    },
    /**
     * @description Émet l'évènement « canceled »
     */
    __onCancel() {
      this.$emit("canceled", this.id);
    },
    /**
     * @description Émet l'évènement « canceled » si le « trigger » est de type « backdrop » ou « esc »
     * @param {Object} trigger Évènement ayant mené à l'appel de la méthode
     */
    __onHide(trigger) {
      if (
        trigger.trigger == "backdrop" ||
        trigger.trigger == "esc" ||
        trigger.trigger == "headerclose"
      ) {
        this.__onCancel();
      }
    }
  }
};
</script>
